const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');
const { handleSEOForCanada } = require('components/LegacyCatalog/utils');
const { userXTimestampHeader } = require('utils/Headers');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Nth+Level+Category+API

function getNthLevelCategory(options) {
    const {
        catalogId,
        catalogSeoName,
        headers = {},
        ...opts
    } = options;
    const catalogService = Sephora.Util.InflatorComps.services.CatalogService;
    let url;
    const isRwd = Sephora.channel === 'RWD';
    url = `/api/catalog/categories/${catalogSeoName}/seo`;
    headers['x-requested-source'] = 'rwd';

    headers['x-timestamp'] = userXTimestampHeader()['x-timestamp'];

    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPCatalog = catalogService && catalogService.isNLPCatalog();
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    const getRefinement = function () {
        if (opts.ref && opts.ref.split(',').length) {
            opts.ref.split(',').forEach(refinement => url += `&ref=${refinement}`);
            delete opts.ref;
        }
    };

    const removeDuplicate = function(fullUrl) {                  
        let query = fullUrl.split('?')[1];               
        let params = query.split('&');                 
        let uniqueArray = params.filter(function(item, pos) {
            return params.indexOf(item) === pos;
        });
        let newUrl;
        newUrl = fullUrl.split('?')[0] + '?';
        newUrl += uniqueArray.join('&');  
        return newUrl;
    };

    if (isNLPInstrumentationEnabled) {
        if (isNLPCatalog && constructorSessionID && constructorClientID) {
            const constructorArgs = isRwd ? '' : `constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}&`;
            url = `${url}?${constructorArgs}targetSearchEngine=${catalogService.catalogEngine}`;
            getRefinement();
        }
    } else {
        url = url + `?targetSearchEngine=${catalogService.catalogEngine}`;
        getRefinement();
    }

    if (Object.keys(opts).length) {
        url += (isNLPCatalog ? '&' : url.indexOf('?') === -1 ? '?' : '&')
         + urlUtils.makeQueryString(opts);
    }

    url = removeDuplicate(url);

    return ufeApi.makeRequest(url, { method: 'GET', headers }).
        then(data => {
            if (data.errorCode) {
                return Promise.reject(data);
            } else {
                Sephora.Util.InflatorComps.services.CatalogService.catalogEngine = data.responseSource;
                return handleSEOForCanada(data);
            }
        });
}

function getCategory(options) {
    const {
        catalogSeoName,
        headers = {},
        ...opts
    } = options;

    let url = `/api/catalog/categories/${catalogSeoName}/seo`;

    if (Object.keys(opts).length) {
        url += '?' + urlUtils.makeQueryString(opts);
    }
    headers['x-requested-source'] = 'rwd';
    headers['x-timestamp'] = userXTimestampHeader()['x-timestamp'];

    return ufeApi.makeRequest(url, { method: 'GET', headers }).then(data => data.errorCode
        ? Promise.reject(data)
        : handleSEOForCanada(data));
}

module.exports = {
    getNthLevelCategory,
    getCategory
};
